export const MAX_VOICE_INPUT_LENGTH = 300
